module.exports = __webpack_public_path__ + "static/img/partnerLogoOne.fac885d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageThree/partnerLogoOne.png
// module id = Z6wb
// module chunks = 0